<div class="uk-width-1-1" style="margin-left: -20px;" uk-grid>
    <div class="uk-margin uk-display-inline-block research-form-controls multi-search-component">
        <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
            <span *ngIf="vehicleLoading === false" class="uk-form-icon uk-form-icon-flip">
                <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
            </span>
            <span *ngIf="vehicleLoading === true" class="uk-form-icon uk-form-icon-flip">
                <div style="width:24px; height: 24px;" uk-spinner></div>
            </span>
            <!-- <input class="multi-search-bar" id="multiSearchBar" type="search" [(ngModel)]="vehicleSearch"
                name="multi-search-bar" autocomplete="off" (ngModelChange)="searchManager($event)"
                (focus)="toggleSuggestions(true)" placeholder="Rechercher" [autocomplete]="'new-password'"
                (focusout)="toggleSuggestions(false)" style="padding-right: inherit !important;"> -->

            <form>
                <input name="multi-recherche" autocomplete="off" id="search-bar" class="search-bar" type="text"
                    (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)" [(ngModel)]="vehicleSearch"
                    (ngModelChange)="searchManager($event)" placeholder="Rechercher" ng-reflect-model="">
            </form>


            <div [class.display-none]="vehicleDisplay === false" class="multi-search-result">
                <!-- <div [class.display-none]="vehicleDisplay === false" class="arrow" style="background-color: red;"> -->
                <!-- </div> -->

                <div
                    [class.display-none]="vehicleNoResult === false || stationNoResult === false || userNoResult === false || reservationNoResult === false">
                    Aucun résultat
                </div>

                <div class="categorie" [class.display-none]="userNoResult === true">
                    <h3>Utilisateur</h3>
                    <!-- <div [class.display-none]="usersOptions.length === 0" class="arrow"></div> -->
                    <ul [class.display-none]="userNoResult === true">
                        <li class="result" *ngFor="let option of usersOptions" (click)="goToUser(option)">
                            <span class="color-orange">{{ option.LastName }} {{ option.FirstName }}</span> - {{
                            option.CodeSociety }}
                        </li>
                    </ul>
                </div>

                <div class="categorie" [class.display-none]="reservationNoResult === true">
                    <h3>Réservation</h3>
                    <!-- <div [class.display-none]="reservationsOptions.length === 0" class="arrow"></div> -->
                    <ul [class.display-none]="reservationNoResult === true">
                        <li *ngFor="let option of reservationsOptions">
                            <span class="color-orange" (click)="goToReservation(option)">{{ option.Code }}</span> - {{
                            option.User }} - {{
                            option.Vehicle }}
                        </li>
                    </ul>
                </div>

                <div class="categorie" [class.display-none]="vehicleNoResult === true">
                    <h3>Véhicules</h3>
                    <ul [class.display-none]="vehicleNoResult === true">
                        <li *ngFor="let option of vehicleOptions" (click)="goToVehicule(option)">
                            <span class="color-orange">{{ option.name }}</span> - {{ option.brand }} {{ option.model
                            }}
                        </li>
                    </ul>
                </div>

                <div class="categorie" [class.display-none]="stationNoResult === true">
                    <h3>Stations</h3>
                    <ul [class.display-none]="stationNoResult === true">
                        <li *ngFor="let option of stationsOptions" (click)="goToStation(option)">
                            {{ option.name }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <div [class.display-none]="vehicleDisplay === false" class="suggestions">
                    <div [class.display-none]="stationsOptions.length === 0" class="arrow"></div>
                    <div [class.display-none]="stationNoResult === false">
                        Pas de stations
                    </div>
                    <div [class.display-none]="vehicleNoResult === true" *ngFor="let option of stationsOptions">
                        {{ option.name }}
                    </div>
                </div> -->
        </div>
    </div>
</div>